{
  "tabs": {
    "chat": "Ingxoxo",
    "reminders": "Izikhumbuzo",
    "calendar": "Ikhalenda",
    "settings": "Izicwangciso"
  },
  "common": {
    "cancel": "Rhoxisa",
    "save": "Gcina",
    "confirm": "Qinisekisa",
    "delete": "Cima",
    "back": "Buyela",
    "close": "Vala",
    "edit": "Hlela",
    "search": "Khangela",
    "all": "Zonke",
    "loading": "Layisha...",
    "error": "Into ayihambanga kakuhle",
    "notFound": "Ayifumanekanga",
    "tryAgain": "Nceda zama kwakhona",
    "retry": "Phinda uzame",
    "undo": "Khubaza",
    "pullToRefresh": "Tsala ukuze uhlaziye",
    "justNow": "kutshanje"
  },
  "auth": {
    "welcome": "Wamkelekile ku FishMemory",
    "tagline": "Uncedisi wakho wezikhumbuzo zeWhatsApp, ngoku ephaketheni lakho.",
    "subtitle": "Uncedisi wakho wezikhumbuzo zeWhatsApp, ngoku ephaketheni lakho.",
    "phoneLabel": "Inombolo yakho yeWhatsApp",
    "phoneHint": "Siza kuthumela ikhowudi yokuqinisekisa ngeWhatsApp",
    "invalidPhone": "Nceda faka inombolo yefowuni esebenzayo",
    "continue": "Qhubeka",
    "enterPhone": "Faka inombolo yakho yeWhatsApp",
    "phonePlaceholder": "Inombolo yefowuni",
    "sendCode": "Thumela Ikhowudi",
    "verifyTitle": "Qinisekisa inombolo yakho",
    "otpSentTo": "Ikhowudi yeedijithi ezi-6 ithunyelwe ku {{phone}} ngeWhatsApp",
    "enterFullCode": "Nceda faka zonke iidijithi ezi-6",
    "invalidOtp": "Ikhowudi ayisebenzi. Nceda zama kwakhona.",
    "otpFailed": "Ayiphumelelanga ukuthumela ikhowudi. Zama kwakhona.",
    "otpResent": "Ikhowudi ithunyelwe kwakhona",
    "resendIn": "Phinda uthumele kwi {{seconds}}s",
    "resendCode": "Phinda uthumele ikhowudi",
    "enterOtp": "Faka ikhowudi ethunyelwe kwi WhatsApp yakho",
    "verify": "Qinisekisa",
    "resend": "Phinda uthumele ikhowudi",
    "wrongNumber": "Inombolo engalunganga?",
    "backToPhone": "Buyela kwinombolo",
    "editPhone": "Hlela inombolo yefowuni",
    "error": "Impazamo",
    "setupTitle": "Masilungise izinto",
    "setupSubtitle": "Ungatshintsha oku nanini na kamva ku Izicwangciso",
    "namePlaceholder": "Igama lakho",
    "letsGo": "Gqiba ukuseta",
    "skipForNow": "Yeka okwexeshana"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Chwetheza umyalezo...",
    "inputPlaceholder": "Chwetheza umyalezo...",
    "typing": "FishMemory iyachwetheza...",
    "online": "Kwi-intanethi",
    "connecting": "Uxhuma...",
    "reconnecting": "Uqhagamshela kwakhona...",
    "offline": "Akukho Intanethi",
    "empty": "Qala ingxoxo",
    "emptyHint": "Yenza izikhumbuzo, jonga ishedyuli yakho, okanye cela uncedo.",
    "emptyAction": "Thumela isikhumbuzo somzekelo",
    "actions": "Izenzo zengxoxo",
    "keep": "Gcina imiyalezo",
    "clearTitle": "Coca ingxoxo",
    "clearConfirm": "Cima yonke imiyalezo kule fowuni? Oku akunakubuyiselwa.",
    "clear": "Coca ingxoxo",
    "optionSelected": "Kukhethiweyo: {{label}}",
    "sendingSelection": "Kuthunyelwa...",
    "connectionLost": "Uqhagamshelo ulahlekile..."
  },
  "reminders": {
    "title": "Izikhumbuzo Zam",
    "active": "Esebentayo",
    "today": "Namhlanje",
    "thisWeek": "Le Veki",
    "history": "Imbali",
    "items": "izinto",
    "emptyTitle": "Akukho zikhumbuzo okwangoku",
    "emptySubtitle": "Yenza esinye kwi ngxoxo kwaye siya kuvela apha.",
    "emptyAction": "Vula ingxoxo",
    "filterActive": "Esebentayo",
    "filterToday": "Namhlanje",
    "filterWeek": "Le Veki",
    "filterHistory": "Imbali",
    "emptyState": "Akukho zikhumbuzo okwangoku. Qalisa ukuthetha!",
    "swipeDone": "Gqityiwe",
    "swipeSnooze": "Yeka okwexeshana",
    "swipeDelete": "Cima",
    "search": "Khangela izikhumbuzo...",
    "upcoming": "Ezizayo",
    "completed": "Zigqityiwe",
    "overdue": "Zidlulile ixesha",
    "tomorrow": "Ngomso",
    "synced": "Zidityaniswe {{value}}",
    "swipeHint": "Swipha isikhumbuzo ukuze uzenze ezinye izenzo",
    "noResults": "Akukho zikhumbuzo ezifanelekileyo koku kufunwa",
    "noResultsHint": "Zama igama elahlukileyo okanye ucime ukukhangela",
    "deleteAllFailed": "Ayiphumelelanga ukucima zonke izikhumbuzo"
  },
  "calendar": {
    "title": "Ikhalenda",
    "today": "Namhlanje",
    "tomorrow": "Ngomso",
    "completed": "ugqityiwe",
    "noEvents": "Akukho ziganeko zicwangcisiweyo",
    "noEventsSubtitle": "Khetha umhla ukubona izikhumbuzo kunye neziganeko zekhalenda.",
    "googleEvent": "Ikhalenda yeGoogle",
    "legendActive": "Esebentayo",
    "legendRecurring": "Phinda-phinda",
    "legendDone": "Gqityiwe",
    "legendGoogle": "Google",
    "previousMonth": "Inyanga edlulileyo",
    "nextMonth": "Inyanga ezayo",
    "previousYear": "Unyaka odlulileyo",
    "nextYear": "Unyaka ozayo",
    "goToToday": "Yiya namhlanje",
    "all": "Zonke",
    "active": "Esebentayo",
    "done": "Gqityiwe",
    "paused": "Misiwe"
  },
  "settings": {
    "title": "Izicwangciso",
    "profile": "Iprofayile",
    "name": "Igama lokubonisa",
    "enterName": "Faka igama lakho",
    "language": "Ulwimi",
    "uiLanguage": "Ulwimi lohlelo",
    "uiLanguageHelp": "Tshintsha ujongano lohlelo, amalebula ekhalenda, kunye nendlela yokubeka kule fowuni kuphela.",
    "serverLanguage": "Ulwimi lwengxoxo",
    "serverLanguageHelp": "Tshintsha ulwimi olusetyenziswa yimpendulo zeseva kunye nemiyalezo yezikhumbuzo kwi-akhawunti yakho.",
    "timezone": "Ixesha lendawo",
    "currentTimezone": "Ixesha lendawo langoku",
    "timezoneHelp": "Zonke iiyure zezikhumbuzo ziboniswa usebenzisa eli xesha lendawo.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Gcina ixesha lendawo",
    "timezoneSaved": "Ixesha lendawo ligciniwe",
    "detect": "Fumanisa",
    "detectFailed": "Akuphumelelanga ukufumanisa ixesha lendawo",
    "autoDetect": "Zifumanise ngokuzenzekelayo nge GPS",
    "notifications": "Izaziso",
    "notificationsHelp": "Izikhumbuzo zokulandela zilawula izaziso eziphindaphindayo emva kokuba isikhumbuzo sithunyelwe. Imvume yezaziso kwi fowuni isalawulwa kwizicwangciso zefowuni yakho.",
    "pushEnabled": "Izaziso eziphushiweyo",
    "autoDoneOnFire": "Zimarke ngokuzenzekelayo xa zivuliwe",
    "autoDoneOnFireDesc": "Xa icinyiwe, izikhumbuzo zihlala zisebenza de umake njenge zigqityiweyo.",
    "googleCalendar": "Ikhalenda yeGoogle",
    "google": "Ikhalenda yeGoogle",
    "googleConnected": "Qhagamshelwe",
    "googleDisconnected": "Akukho Qhagamshelo",
    "googleConnectedHelp": "Izikhumbuzo ezintsha zinokudityaniswa ngokuzenzekelayo nekhalenda yakho.",
    "googleDisconnectedHelp": "Qhagamshela Ikhalenda yeGoogle ukuze ugcine izikhumbuzo neziganeko zihambelana.",
    "googleConnectFailed": "Ayiphumelelanga ukuqhagamshela Ikhalenda yeGoogle",
    "connected": "Qhagamshelwe",
    "disconnected": "Akukho Qhagamshelo",
    "connect": "Qhagamshela",
    "disconnect": "Yeka uqhagamshelo",
    "autoSync": "Dityanisa ngokuzenzekelayo izikhumbuzo ezintsha",
    "autosync": "Dityanisa ngokuzenzekelayo izikhumbuzo ezintsha",
    "subscription": "Ubhaliso",
    "trialUsed": "Uvavanyo: {{used}}/{{total}} lusetyenzisiwe",
    "trialStatus": "Uvavanyo luyafumaneka",
    "activeStatus": "Ubhaliso olusebenzayo",
    "expiredStatus": "Ubhaliso luphelelwe lixesha",
    "unsubscribedStatus": "Akabhaliswanga",
    "about": "Malunga",
    "version": "Inguqulelo",
    "logout": "Phuma",
    "logoutTitle": "Phuma",
    "logoutConfirm": "Uqinisekile ukuba ufuna ukuphuma?",
    "noName": "Akukho gama limiselweyo",
    "serverConnection": "Uqhagamshelo lweseva",
    "serverUrl": "URL yeseva",
    "serverEdit": "Hlela",
    "saveReconnect": "Gcina uze uqhagamshele kwakhona",
    "resetDefault": "Buyisela kwimeko yesiqhelo",
    "invalidServerUrlTitle": "URL yeseva ayisebenzi",
    "invalidServerUrlMessage": "Faka i-URL yeseva esebenzayo ye http okanye https, umzekelo https://example.com",
    "uiLanguageChangeFailed": "Akuphumelelanga ukutshintsha ulwimi lohlelo. Nceda zama kwakhona.",
    "serverLanguageChangeFailed": "Akuphumelelanga ukutshintsha ulwimi lwengxoxo. Nceda zama kwakhona.",
    "timezoneChangeFailed": "Akuphumelelanga ukutshintsha ixesha lendawo. Nceda zama kwakhona.",
    "autoSyncChangeFailed": "Akuphumelelanga uhlaziyo lwe-auto-sync. Nceda zama kwakhona.",
    "nameChangeFailed": "Akuphumelelanga uhlaziyo lwegama lokubonisa. Nceda zama kwakhona.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Iinkcukacha zesikhumbuzo",
    "editTime": "Hlela Ixesha",
    "rename": "Guqula igama",
    "snooze": "Yeka okwexeshana",
    "snooze15": "Yeka okwexeshana imizuzu eli-15",
    "pause": "Misa",
    "pauseReminder": "Misa isikhumbuzo",
    "resume": "Qhubeka",
    "resumeReminder": "Qhubeka nesikhumbuzo",
    "skip": "Yeka Okulandelayo",
    "skipOccurrence": "Yeka esi siganeko",
    "syncGoogle": "Dityanisa neGoogle",
    "delete": "Cima",
    "deleteTitle": "Cima Isikhumbuzo",
    "deleteConfirm": "Esi sikhumbuzo siza kucinywa ngonaphakade.",
    "deleteRecurringTitle": "Cima Isikhumbuzo Esiphindaphindayo",
    "deleteRecurringMessage": "Ufuna ukushiya esi siganeko okanye ucime lonke uthotho?",
    "deleteThisOccurrence": "Yeka esi Siganeko",
    "deleteEntireSeries": "Cima Lonke Uthotho",
    "done": "Gqityiwe",
    "markDone": "Marka njenge igqityiweyo",
    "undo": "Buyisela",
    "undoPrompt": "Uyayidinga isebenze kwakhona? Buyisela ngoku.",
    "recurring": "Phindaphinda",
    "nextRun": "Okulandelayo",
    "oneTime": "Ngesinye ixesha",
    "pending": "Ilindile",
    "sent": "Ithunyelwe",
    "paused": "Imisiwe",
    "active": "Esebentayo",
    "snoozed": "Yekile okwexeshana",
    "localTime": "Iboniswe ngexesha lendawo yakho",
    "recurrence": "Ukuphindaphinda",
    "created": "Yenziwe",
    "tags": "Iithegi",
    "fireCount": "Amaxesha avuliweyo",
    "actions": "Izenzo",
    "none": "Akukho",
    "snoozeFailed": "Ayiphumelelanga ukuyeka okwexeshana isikhumbuzo",
    "pauseFailed": "Ayiphumelelanga ukumisa isikhumbuzo",
    "resumeFailed": "Ayiphumelelanga ukuqhubeka nesikhumbuzo",
    "skipFailed": "Ayiphumelelanga ukuyeka isikhumbuzo",
    "doneFailed": "Ayiphumelelanga ukumaka isikhumbuzo njenge sigqityiweyo",
    "undoFailed": "Ayiphumelelanga ukubuyisela imeko yesikhumbuzo",
    "deleteFailed": "Ayiphumelelanga ukucima isikhumbuzo",
    "rescheduleTitle": "Ulungise ixesha?",
    "rescheduleMsg": "Esi sikhumbuzo sidlulile ixesha. Ngaba ungathanda ukusilungisa kwakhona?",
    "reschedule15": "Emizuzwini eli-15",
    "reschedule60": "Eli xesha li-1",
    "keepOverdue": "Gcina njengoko injalo"
  },
  "onboarding": {
    "slide1Title": "Wamkelekile ku FishMemory",
    "slide1Sub": "Uncedisi wakho wezikhumbuzo zomntu siqu — usebenzisa iWhatsApp kwaye yakhelwe ephaketheni lakho.",
    "slide2Title": "Thetha nje Ngokwendalo",
    "slide2Sub": "Chwetheza izikhumbuzo ngendlela ocinga ngayo: \"Khumbuza ukundowuza umama ngomso ngo-3pm\" — siza kulawula konke okunye.",
    "slide3Title": "Ungaphoswa Nanto",
    "slide3Sub": "Fumana izaziso ngexesha, ulungelelanise ngeethegi, kwaye uhlale uphambili kuyo yonke into ebalulekileyo.",
    "getStarted": "Qalisa",
    "next": "Okulandelayo",
    "firstReminderTitle": "Yenza isikhumbuzo sakho sokuqala!",
    "firstReminderHint": "Zama ukuchwetheza into enjengale:",
    "firstReminderExample": "Khumbuza ukusela amanzi ngomso ngo-9 AM",
    "gotIt": "Kuyacaca!",
    "notifRationaleTitle": "Hlala Ngexesha",
    "notifRationaleBody": "FishMemory ifuna izaziso ukukukhumbuza ngexesha. Uza kufumana izaziso kuphela kwizikhumbuzo ozidalayo.",
    "notifRationaleAllow": "Vumela Izaziso",
    "notifRationaleLater": "Mhlawumbi Kamva",
    "swipeHint": "Swipha ekunene ukuze wenze izenzo ngokukhawuleza →",
    "calendarDragHint": "Tsala ukwandisa ↕"
  }
}
